(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c-purchase-cta"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.c-purchase-cta__form')) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true' || !form.reportValidity()) return;

    const button = form.querySelector('[type="submit"]');
    const errorMessage = form.querySelector('.c-purchase-cta__error');
    const drawer = document.getElementById('Cart-Drawer');
    const toggle = document.getElementById('cart-drawer-toggle');
    errorMessage.hidden = true;
    errorMessage.textContent = '';

    if (!drawer || !toggle || !window.cartDrawer) {
      errorMessage.textContent = form.dataset.drawerError;
      errorMessage.hidden = false;
      console.error('Purchase CTA: cart drawer is unavailable.');
      return;
    }

    form.dataset.submitting = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    let added = false;

    try {
      const sections = window.cartDrawer.getSectionsToRender();
      const formData = new FormData(form);
      formData.delete('return_to');
      formData.set('sections', sections.map((section) => section.section).join(','));
      formData.set('sections_url', window.location.pathname);
      const url = new URL(form.action, window.location.origin);
      url.pathname = url.pathname.replace(/\/add(?:\.js)?$/, '/add.js');
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || form.dataset.cartError);
      }
      added = true;

      dispatchCustomEvent('cart:item-added', {
        product: result.items ? result.items[0] : result
      });

      const replacements = sections.map((section) => {
        const container = document.getElementById(section.id);
        if (!container) throw new Error(form.dataset.refreshError);
        const html = result.sections?.[section.section];
        if (!html) throw new Error(form.dataset.refreshError);
        const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
        if (!replacement) throw new Error(form.dataset.refreshError);
        return { target: container.querySelector(section.selector) || container, replacement };
      });
      replacements.forEach(({ target, replacement }) => {
        target.innerHTML = replacement.innerHTML;
      });
      window.cartDrawer.reinit();
      toggle.click();
    } catch (error) {
      console.error('Purchase CTA:', error);
      errorMessage.textContent = added ? form.dataset.refreshError : error.message || form.dataset.cartError;
      errorMessage.hidden = false;
    } finally {
      form.dataset.submitting = 'false';
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
